<nb-accordion *ngIf="remindersData.length" class="request-accordion">
  <nb-accordion-item class="request-list-container">
    <nb-accordion-item-header>
      <div class="request-list" fxLayout="row">
        <div
          class="request-count-circle"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <div class="count">{{ remindersData.length }}</div>
        </div>
        <div class="request-title">
          <span>{{ remindersHeading }}</span>
        </div>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <ng-container *ngFor="let item of remindersData">
        <div class="reminders-content">
            <div
              class="content-body"
              fxFlex="100"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <!-- <div class="icon" fxFlex="10" fxFlex.lt-sm="15">
                <img
                  [src]="
                    item.timeDifference
                      ? 'assets/icons/bell.png'
                      : 'assets/icons/bell.png'
                  "
                  alt="img_icon"
                />
              </div> -->
              <div class="content" fxFlex="70">
                {{ item.title }}
              </div>
              <div
                class="time"
                fxFlex="30"
                fxFlex.lt-sm="40"
                fxLayout="row"
                fxLayoutAlign="center center"
              >
                {{ item?.dueDate }}
              </div>
            </div>
        </div>
      </ng-container>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>

<!-- <div class="reminder-container" *ngIf="remindersData.length">
  <ng-container>
    <div class="heading">
      <span class="header-title">{{ remindersHeading }}</span>
    </div>
    <div class="reminders-content">
      <ng-container *ngFor="let item of remindersData">
        <div
          class="content-body sub-heading-white"
          fxFlex="100"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div class="icon" fxFlex="10" fxFlex.lt-sm="15">
            <img
              [src]="
                item.timeDifference
                  ? 'assets/icons/bell.png'
                  : 'assets/icons/bell.png'
              "
              alt="img_icon"
            />
          </div>
          <div class="content" fxFlex="70">
            {{ item.title }}
          </div>
          <div
            class="time sub-heading-white"
            fxFlex="30"
            fxFlex.lt-sm="40"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            {{ item?.dueDate }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div> -->
